/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
// styles
import injectSheet from 'react-jss';
import styles from './emojipreview_styles';
import Space from 'material/space/space';
// TODO: Move this to material folder
import Emoji from 'pages/dashboard/commenting/commentingconfigv2/sitethemesection/components/emoji/emoji';

const emojisDefaultCount = {
  'LIKE': '1.2k',
  'DISLIKE': '97',
  'LOVE': '683',
  'FUNNY': '1.8k',
  'SAD': '45',
  'SHOCKED': '88',
  'ANGRY': '267',
  'THOUGHTFUL': '7'
}
const EmojiStat = ({ emojiName, emojiType, showReactionCount, active }) => {
  return (
    <Space gap={4} alignItems={'center'} justifyContent={'center'} direction={'column'} klass={`emoji active-${active}`}>
      <Emoji size={28} name={emojiName} type={emojiType || 'FLAT'} />
      {showReactionCount && <span>{emojisDefaultCount[emojiName]}</span>}
    </Space>
  )
}

const EmojiPreviewPlaceholder = () => {
  return Array(4).fill(0).map(() =>  (
    <Space gap={2} alignItems={'center'} justifyContent={'center'} direction={'column'}>
      <div className='emojiplaceholder' />
      <div className='countplaceholder' />
    </Space>
  ))
}

const defaultEmojis = [
   'LIKE',
   'DISLIKE',
   'LOVE',
   'FUNNY',
   'SAD',
   'SHOCKED',
   'ANGRY',
   'THOUGHTFUL'
]
/* ========== ~~~~~~~~~~ EMOJI PREVIEW ~~~~~~~~~~ ========== */
const EmojiPreview = injectSheet(styles)(props => {

  const { headline, emojis, emojiReactionTotal, showEmojiReactionCount, showPlaceholder, emojiType, totalReactionsLabel } = props
    return (
      <div className={`emojipreview ${props.classes.emojipreview}`}>
       {headline && <h3>{headline}</h3>}
        {showPlaceholder ? 
        <Space alignItems={'center'} justifyContent={'center'} direction={'column'} gap={0} style={{ maxWidth: '330px'}} >
          <div style={{ width: '100%', height: '12px', marginBottom: '16px', background: '#DFDFDF', borderRadius: '8px' }}/>
          <div className='emojicontainer' style={{ gap: 0 }}>
            <EmojiPreviewPlaceholder />
          </div>
          <div className='emojicontainer' style={{ gap: 0, borderTopLeftRadius: 0, borderTopRightRadius: 0, top: '-10px', position: 'relative' }}>
            <EmojiPreviewPlaceholder />
          </div>
        </Space>
        :
        <div className='emojicontainer'>
          {(emojis || defaultEmojis).map((emoji, index) => (
              <EmojiStat emojiName={emoji} emojiType={emojiType || 'FLAT'} showReactionCount={showEmojiReactionCount} active={Math.round((emojis || defaultEmojis).length / 2) === index}  />
          ))}
        </div>
      }
       {emojiReactionTotal && <span>{emojiReactionTotal} {totalReactionsLabel || 'Total Reactions'}</span>}
      </div>
    )
})


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default EmojiPreview;
